(function () {
  function deriveSuggestedLanguage(navigatorLanguage, currentLanguage, availableLanguages) {
    if (!navigatorLanguage || !Array.isArray(availableLanguages)) return null;
    var code = String(navigatorLanguage).slice(0, 2).toLowerCase();
    if (!code) return null;
    if (code === String(currentLanguage || '').toLowerCase()) return null;
    return availableLanguages.map(function (l) { return String(l).toLowerCase(); }).indexOf(code) !== -1 ? code : null;
  }

  // Decide whether/how to surface the geolocation popup. Returns a `mode`:
  //   'market'      - detected country is a market we sell to, different from the current one
  //                   ("Shopping from <country>?"). `country` is that market (safe to prefill).
  //   'unavailable' - detected country is NOT a market we sell to ("We don't ship to <country>").
  //                   `country` is the detected country for DISPLAY ONLY — never a valid country_code.
  //   'language'    - no country action, only a language suggestion. `country` is null.
  //   null          - nothing to show (suppressed, or detected equals current with no suggestion).
  // A debug country bypasses suppression and flows through the same market/unavailable logic,
  // so `?geo_debug=XX` can exercise either popup.
  function decideGeoSuggestion(input) {
    input = input || {};
    var debugCountry = input.debugCountry || null;
    var detectedCountry = debugCountry || input.detectedCountry || null;
    var currentCountry = input.currentCountry || null;
    var available = Array.isArray(input.availableCountries) ? input.availableCountries : [];
    var suggestedLanguage = input.suggestedLanguage || null;
    var dismissedCountry = debugCountry ? null : (input.dismissedCountry || null);

    var closed = { open: false, mode: null, country: null, language: null };

    var suppressed = !!dismissedCountry && dismissedCountry === detectedCountry;
    if (suppressed) return closed;

    var inMarket = !!detectedCountry && available.indexOf(detectedCountry) !== -1;

    if (inMarket && detectedCountry !== currentCountry) {
      return { open: true, mode: 'market', country: detectedCountry, language: suggestedLanguage };
    }
    if (!!detectedCountry && !inMarket) {
      return { open: true, mode: 'unavailable', country: detectedCountry, language: suggestedLanguage };
    }
    if (suggestedLanguage) {
      return { open: true, mode: 'language', country: null, language: suggestedLanguage };
    }
    return closed;
  }

  var api = { deriveSuggestedLanguage: deriveSuggestedLanguage, decideGeoSuggestion: decideGeoSuggestion };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
  if (typeof window !== 'undefined') { window.GeoDetect = api; }
})();
